import BaseDecorator from "./BaseDecorator";

export default class FacilityDecorator extends BaseDecorator {}



// WEBPACK FOOTER //
// ./src/lib/decorators/FacilityDecorator.js